@if (isDesktop) {
  <app-desktop-warning></app-desktop-warning>
}
<app-cookie-banner></app-cookie-banner>
@if (!isDesktop) {
  <div class="app-wrapper">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>
}
